import { useEffect, useRef } from "react";
import { useScrollLock } from "../hooks/useScrollLock";
import { PulseLoader } from "react-spinners";

export default function ModalStructure({ 
  openModal, setOpenModal, title, body, btnText, onSubmit, hideOnFocuse, titleClass, cancelText = 'Annuler', wrapperClass,
  handleModalClose, noFooter, isSubmitting = false
}) {

  const { lockScroll, unlockScroll } = useScrollLock();

  const handleClose = () => {
    unlockScroll();
    setOpenModal(false);
    handleModalClose && handleModalClose();
  }

  // Pour verrouiller le scroll en arriere plan quand la modal est ouverte
  useEffect(() => {
    if (openModal) {
      lockScroll()
    } else {
      unlockScroll()
    }
  }, [openModal]);
  

  const submit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    if (onSubmit) {
      await onSubmit();
    } else {
      handleClose();
    }
  }

  const mouseDownPosRef = useRef(null);
  const mouseMovedRef = useRef(false);
  const mouseButtonRef = useRef(null); // Nouveau ref pour tracker le bouton de la souris
  
  const handleMouseDown = (e) => {
    // Enregistrez la position initiale du clic ET le bouton utilisé
    mouseDownPosRef.current = { x: e.clientX, y: e.clientY };
    mouseButtonRef.current = e.button; // 0 = clic gauche, 2 = clic droit
    mouseMovedRef.current = false;
  };
  
  const handleMouseMove = (e) => {
    // Si aucun clic n'a été enregistré, sortir
    if (!mouseDownPosRef.current) return;
    
    // Calculer la distance parcourue par la souris
    const dx = Math.abs(e.clientX - mouseDownPosRef.current.x);
    const dy = Math.abs(e.clientY - mouseDownPosRef.current.y);
    
    // Si la souris a bougé de plus de 5 pixels dans n'importe quelle direction,
    // considérez que c'est un mouvement de glisse
    if (dx > 5 || dy > 5) {
      mouseMovedRef.current = true;
    }
  };
  
  const handleMouseUp = (e) => {
    // Vérifier que c'est un clic gauche (bouton 0) et non un clic droit
    if (
      e.target.className === 'change-category-container more-info-container change-category-active' && 
      !mouseMovedRef.current &&
      mouseButtonRef.current === 0 // Seulement pour le clic gauche
    ) {
      handleClose();
    }
    
    // Réinitialiser les références
    mouseDownPosRef.current = null;
    mouseButtonRef.current = null;
  };


  return (
    <>
      <div 
        className={`change-category-container more-info-container ${openModal ? 'change-category-active' : ''}`} 
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
      >
        <div className={`change-category-wrapper pl-0 ${openModal ? 'change-category-active' : ''} ${wrapperClass}`}>
          <i className="bi bi-x-lg close-input-change-category" onClick={handleClose}></i>
          <div className="header pt-4 pb-4 border-b border-b-zinc-400">
            <h1 className={`${titleClass}`}>{title}</h1>
          </div>
          {body}
          <div className="submit-modal-container">
            {cancelText && <p className="btn-add gray" onClick={handleClose}>{cancelText}</p>}
            {btnText && 
              <button className={`btn-add black`} onClick={submit}>
                {isSubmitting ? <PulseLoader color="#fff" size={6} /> : btnText}
              </button>
            }
          </div>
        </div>
      </div>
    </>
  )
}